/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { GoalsAndInterventionsViewModel } from './GoalsAndInterventionsViewModel'; 

export function getGoalsAndInterventionsByCertificationPeriodOptions(certificationPeriodId: string, onSuccess?: (result: GoalsAndInterventionsViewModel) => void) {
	return queryOptions({
		queryKey: ['goals-and-interventions-by-certification-period', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/queries/getgoalsandinterventionsbycertificationperiod/' + certificationPeriodId;
			const resp = await axios.get<GoalsAndInterventionsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}